import { TableCell, Checkbox, TextField } from "@mui/material";
import type { childPartV2Param } from "@/api/breakdownService";

interface ChildPartDataEditProps {
  partNo: string;
  processCount?: number;
  newChildPart: childPartV2Param | null;
  setNewChildPart: React.Dispatch<
    React.SetStateAction<childPartV2Param | null>
  >;
  validationErrors: Set<string>;
}

const ChildPartDataEdit = ({
  partNo,
  processCount,
  newChildPart,
  setNewChildPart,
  validationErrors,
}: ChildPartDataEditProps) => {
  return (
    <>
      <TableCell
        sx={{
          position: "sticky",
          left: 0,
          zIndex: 101,
          width: 70,
          minWidth: 70,
          maxWidth: 70,
          textAlign: "center",
          backgroundColor: "#fffbe6",
          borderRight: "1px solid #e0e0e0",
        }}
        rowSpan={processCount || 1}
      >
        <Checkbox disabled />
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          zIndex: 101,
          left: 70,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          backgroundColor: "#fffbe6",
          borderRight: "2px solid #e0e0e0",
          padding: 1,
          fontWeight: "500",
          fontSize: "0.9rem",
        }}
        rowSpan={processCount || 1}
      >
        {newChildPart?.no || partNo + ".X"}
      </TableCell>
      <TableCell
        sx={{
          position: "sticky",
          zIndex: 101,
          left: 220,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          backgroundColor: "#fffbe6",
          borderRight: "2px solid #e0e0e0",
          padding: 1,
          fontWeight: "500",
          fontSize: "0.9rem",
        }}
        rowSpan={processCount || 1}
      >
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          value={newChildPart?.name}
          onChange={(e) => {
            setNewChildPart((prev) =>
              prev ? { ...prev, name: e.target.value } : null,
            );
          }}
          error={validationErrors.has("name")}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: validationErrors.has("name")
                ? "#d32f2f"
                : undefined,
              borderWidth: validationErrors.has("name") ? 2 : 1,
            },
          }}
        />
      </TableCell>
    </>
  );
};

export default ChildPartDataEdit;
